import { useContext, useEffect } from "react"
import { GlobalMachineContext } from "../../../study-plans/pages/StudyPlansInit/StudyPlansInit"
import { ProgramsContext } from "../../../../mp-shared-components/ready-shared-components/components/Navs"
import { Program } from "../../../../../types/gqlTypes/graphql"
import { useFilterStateContext } from "../../../../reporting/providers/FiltersStateProvider"

export const useProgramSync = () => {
  const { currentProgram } = useContext(ProgramsContext)
  const { state: filtersState } = useFilterStateContext() ?? {}
  const { isOldNav, isStudyPlanV2Enabled } = GlobalMachineContext.useSelector(
    state => ({
      isOldNav: state.context.isOldNav,
      isStudyPlanV2Enabled: state.context.isStudyPlanV2Enabled
    })
  )
  const { send } = GlobalMachineContext.useActorRef()

  // Old Nav: Listen to ProgramsContext
  useEffect(() => {
    if (isOldNav && currentProgram) {
      send({
        type: "CHANGE_PROGRAM",
        program: currentProgram.toUpperCase() as Program
      })
    }
  }, [currentProgram, isOldNav])

  // New Nav: Listen to filters
  useEffect(() => {
    if (!isOldNav && filtersState?.test?.[0] && !isStudyPlanV2Enabled) {
      // Only handle single program selection (study plans don't support multiple)
      if (filtersState.test.length > 1) return

      const [filterProgram, filterSubject] = filtersState.test[0].split("_")

      send({
        type: "CHANGE_PROGRAM",
        program: filterProgram,
        subject: filterSubject
      })
    }
  }, [filtersState?.test, isOldNav, isStudyPlanV2Enabled])
}
